'use strict';

module.exports = function () {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-util/lib/can-use-dom.js
// module id = 302
// module chunks = 0